BX.Vue.component('aos__docs-for-sign', {
  data: function () {
    return {
      modal: null,
      documents: [],
      archive: null,
      isLoaded: false,
      canSign: false,
      attemptConnection: 0,
      flags: {
        resetProcess: false,
      },
    };
  },
  methods: {
    getDocsForSign: function (isWaitingStart, id) {
      const vm = this;

      if (isWaitingStart) {
        vm.$parent.blurLoader(vm.$parent.aos, true);
        vm.attemptConnection = vm.$parent.options.timeoutConnection;
      } else {
        if (vm.attemptConnection > 0) {
          --vm.attemptConnection;
        } else {
          vm.attemptConnection = 0;
        }
      }

      BX.ajax
        .runComponentAction('aton:aos', 'docsForSign', {
          url: location.pathname,
          method: 'post',
          mode: 'class',
          data: {
            isWaiting: vm.attemptConnection !== 0 ? 'Y' : 'N',
            id: id ? id : '',
          },
        })
        .then(function (request) {
          const requestData = request.data;

          if (requestData?.status === 'success' || requestData?.data?.documents) {
            vm.$parent.blurLoader(vm.$parent.aos, false);
            vm.isLoaded = true;
            vm.documents = requestData?.data?.documents;
            vm.archive = requestData?.data?.archive;
          } else if (requestData?.status === 'waiting') {
            setTimeout(function () {
              vm.getDocsForSign(false, requestData.data.id);
            }, 1000);
          } else {
            vm.isLoaded = true;
            vm.$refs.list.innerHTML = `<div class="ocf__info">
                                                <div class="ocf__info-block">
                                                <div class="ocf__info-desc">${requestData.message}</div>
                                                <div class="ocf__info-phone"></div>
                                              </div>
                                            </div>`;
            vm.$parent.messageError(requestData.data.message);
            vm.$parent.blurLoader(vm.$parent.aos, false);
          }
        })
        .catch(function () {
          vm.isLoaded = true;
          vm.$parent.blurLoader(vm.$parent.aos, false);
          vm.$parent.messageError(vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_ERROR_DEFAULT'));
        });
    },
    checkUserReviewDocuments: function (
      _doc = null,
      downloadAll = false,
      onlyCheck = false,
    ) {
      const vm = this;

      if (!vm.documents.length) return false;

      let allDocsDownloaded = true;

      vm.documents = vm.documents.map((doc) => {
        if (!_doc && !downloadAll) return doc;

        if ((_doc?.url === doc.url && !downloadAll) || downloadAll) {
          doc = {
            ...doc,
            downloaded: true,
          };

          if (!onlyCheck && !downloadAll && _doc?.url === doc.url) {
            vm.actionDoc(_doc);
          }
        }

        if (!doc.downloaded) allDocsDownloaded = false;

        return doc;
      });

      if (!onlyCheck && downloadAll && _doc) {
        vm.actionDoc(_doc);
      }

      vm.canSign = allDocsDownloaded;
    },
    actionDoc: function (doc) {
      const vm = this;

      // до появления окна сохранения файла блокируем экран, иначе можно
      // успеть нажать «Подписать документы» и уйти со шага до скачивания
      vm.$parent.blurLoader(vm.$parent.aos, true);

      fetch(doc.url)
        .then((res) => res.blob())
        .then((blob) => {
          if (doc.name && doc.fileType) {
            const blobObj = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.style.display = 'none';
            anchor.href = blobObj;
            anchor.download = doc.name + '.' + doc.fileType;
            document.body.appendChild(anchor);
            anchor.click();
            window.URL.revokeObjectURL(blobObj);
            anchor.remove();
          }
        })
        .catch(() => {
          vm.$parent.messageError(vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_ERROR_DEFAULT'));
        })
        .finally(() => {
          vm.$parent.blurLoader(vm.$parent.aos, false);
        });
    },
    viewDoc: function (doc) {
      if (doc) {
        window.open(`${doc.url}?view`, '_blank', 'fullscreen=yes');
        this.checkUserReviewDocuments(doc, false, true);
      }

      return false;
    },
    resetProcessAction: function (isWaitingStart, id) {
      let vm = this;

      vm.$refs?.changeInfoPopupButton.classList.add('clicked');

      if (isWaitingStart && vm.flags.resetProcess) {
        return false;
      }

      if (isWaitingStart) {
        vm.flags.resetProcess = true;
        vm.$parent.blurLoader(vm.$parent.aos, true);
        vm.attemptConnection = vm.$parent.options.timeoutConnection;
      } else {
        if (vm.attemptConnection > 0) {
          --vm.attemptConnection;
        } else {
          vm.attemptConnection = 0;
        }
      }

      BX.ajax
        .runComponentAction('aton:aos', 'resetProcess', {
          url: location.pathname,
          method: 'post',
          mode: 'class',
          data: {
            isWaiting: vm.attemptConnection > 0 ? 'Y' : 'N',
            id: id ? id : '',
          },
        })
        .then(function (request) {
          vm.flags.resetProcess = false;
          if (request.status === 'success') {
            let requestData = request.data;

            if (requestData.status === 'success') {
              vm.$refs?.changeInfoPopupButton.classList.remove('clicked');
              vm.$parent.blurLoader(vm.$parent.aos, false);

              // откат процесса возможен только с подтверждённым email,
              // флаг нужно проставить до смены шага, иначе анкета отрисует
              // кнопку подтверждения email заново
              vm.$parent.isEmailValidate =
                'emailValidated' in requestData ? requestData.emailValidated : true;

              if (requestData.data && Object.keys(requestData.data).length > 0) {
                if (requestData.data.clientData) {
                  vm.$parent.clientData = requestData.data.clientData;
                }
              }
              vm.$parent.step = 'SELECT_ENTER_DATA';

              if (typeof aAOSForm !== 'undefined') {
                aAOSForm?.init();
              }
            } else if (requestData.status === 'waiting') {
              setTimeout(function () {
                vm.resetProcessAction(false, requestData.data.id);
              }, 1000);
            } else if (requestData.status === 'error') {
              vm.$parent.messageError(requestData.data.message);
              vm.$parent.blurLoader(vm.$parent.aos, false);
            }
          } else {
            vm.$parent.messageError(
              vm.$parent.msg('A_AOS_INITIAL_DATA_DEFAULT_PHONE_CODE'),
            );
            vm.$parent.blurLoader(vm.$parent.aos, false);
          }
        })
        .catch(function () {
          vm.flags.resetProcess = false;
          vm.$parent.messageError(
            vm.$parent.msg('A_AOS_INITIAL_DATA_DEFAULT_PHONE_CODE'),
          );
          vm.$parent.blurLoader(vm.$parent.aos, false);
        });
    },
    signDocuments: function () {
      const vm = this;
      vm.$parent.step = 'DOCS_SMS_SIGN';
    },
    disclaimerAction: function () {
      let vm = this;
      let opts = vm.$parent.content.initialData.options;
      let docs = [
        {
          url: opts?.OA_DOCUMENT_OFFER_EDO || null,
          text: vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_EDO'),
          key: '#EDO#',
        },
        {
          url: opts?.OA_DOCUMENT_RISK_STATEMENT || null,
          text: vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_RISK'),
          key: '#RISK#',
        },
      ];

      let str = vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_DISCLAIMER_V2');

      docs.forEach((d) => {
        str = str.replace(
          d.key,
          d.url ? `<a target="_blank" href='${d.url}'>${d.text}</a>` : d.text,
        );
      });

      return str;
    },
  },
  computed: {
    docsForSignSubtitle: (vm) => vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_SUBTITLE'),
    modalTitle: (vm) => vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_MODAL_TITLE'),
    modalDescription: (vm) => vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_MODAL_DESCRIPTION'),
    modalBtn: (vm) => vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_MODAL_BTN'),
    signSmsBtnTooltip: (vm) => vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_SMS_TOOLTIP'),
    disclaimer: (vm) => vm.disclaimerAction(),
  },
  watch: {
    documents(list) {
      const vm = this;

      if (
        list.length &&
        vm.isLoaded &&
        vm.$refs.docsForSign &&
        !vm.$parent.changeInfoPopup
      ) {
        let tempInt = setInterval(function () {
          vm.$parent.changeInfoPopup =
            vm.$refs.docsForSign.querySelector('#changeInfoPopup');

          if (vm.$parent.changeInfoPopup) {
            clearInterval(tempInt);
            vm.modal = document.getElementById('popup-window');
            vm.modal.insertAdjacentElement('beforeend', vm.$parent.changeInfoPopup);
          }
        }, 300);
      }
    },
  },
  mounted: function () {
    const vm = this;
    vm.$parent.titleClass = 'ocf__section-title__docs_for_sign';
    vm.$parent.title = vm.$parent.msg('A_AOS_DOCS_FOR_SIGN_TITLE');
    vm.$parent.blurLoader(vm.$parent.aos, true);
    vm.getDocsForSign(true);
    vm.$parent.removeMessageError();
    vm.$parent.scrollToElement('._aos', 0);
  },
  template: `
      <div ref="docsForSign" class="aos__docs-for-sign">
      <div class="aos__docs-desc" v-html="disclaimer"/>
      <div class="ocf__section ocf__section-visible">
        <div class="ocf__block aos__docs-content">
          <template v-if="documents?.length > 0 && isLoaded">
            <div class="aos-docs-list">
              <div class="aos-docs-list__item" v-for="(document, idx) in documents" :key="idx" @click.prevent="viewDoc(document)">
                <p class="aos-docs-list__name t2">{{document?.name}}</p>
                <div class="aos-docs-list__controls">
                  <button class="aos-docs-list__btn -print" @click.prevent="viewDoc(document)" type="button" />
                  <a class="aos-docs-list__btn -download" @click.prevent.stop="checkUserReviewDocuments(document)" :href="document.url" />
                </div>
              </div>
            </div>
            
            <p class="ocf__section-subtitle t2">{{ docsForSignSubtitle }}</p>
            <div class="aos__docs-buttons">
              <button
                v-if="archive"
                class="button-2024 ocf__info-button -download"
                @click.prevent.stop="checkUserReviewDocuments(archive, true)"
              >
                {{ $parent.msg('A_AOS_DOCS_FOR_SIGN_DOWNLOAD_ALL') }}
              </button>
              <button disabled class="button-2024 ocf__info-button -sign-sms" :class="{'tooltip': !canSign}"
                      @click.prevent="signDocuments" :disabled="!canSign">
                <span>{{ $parent.msg('A_AOS_DOCS_FOR_SIGN_SMS') }}</span>
                <span class="tooltip-text" v-html="signSmsBtnTooltip"/>
              </button>
              <a class="button-2024 -outline ocf__info-button -edit open-popup" href="#changeInfoPopup">
                {{ $parent.msg('A_AOS_DOCS_FOR_SIGN_RESET_PROCESS') }}
              </a>
            </div>
            <div class="popup-window popup-confirm" id="changeInfoPopup" style="display:none;">
              <a href="#" class="popup-confirm__close close-popup" ref="closeBtn"></a>
              <div class="popup-confirm__content">
                <h2 class="h3">{{ modalTitle }}</h2>
                <p class="t1" v-html="modalDescription"/>
                <button ref="changeInfoPopupButton" class="button-2024 dark-blue"
                        @click="resetProcessAction(true, '', $event)">{{ modalBtn }}
                </button>
              </div>
            </div>
          </template>
          <div v-else ref="list" class="aos__docs-loader"/>
        </div>
      </div>
      </div>
    `,
});
